export default "__VITE_ASSET__DcvlYIRA__"